// RejectAdditionalPage.js
import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import "../invite.css";

const RejectAdditionalPage = () => {
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(null);
  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const projAddItemId = new URLSearchParams(window.location.search).get("adwid");

    const handleReject = async () => {
      if (!projAddItemId) {
        console.warn("❌ Missing projAddItemId in query string");
        setSuccess(false);
        setLoading(false);
        return;
      }

      try {
        // 🔹 Step 1: Get customer data with new API (POST)
        let getCustData;
        try {
          const getCustRes = await fetch(
            `${BASE_URL}/Customer/GetProjAddItemByProAddItemID_ByCust_New`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ ID: parseInt(projAddItemId) }),
            }
          );

          if (!getCustRes.ok) throw new Error(`API failed with status ${getCustRes.status}`);
          getCustData = await getCustRes.json();
        } catch (err) {
          throw new Error("Failed to fetch customer ID: " + err.message);
        }

        if (!getCustData?.isSuccess || !getCustData.customerID) {
          throw new Error(getCustData?.message || "Invalid customer data from API");
        }

        const customerID = getCustData.customerID;

        // 🔹 Step 2: Send rejection request with statusID = 2
        try {
          const response = await fetch(
            `${BASE_URL}/ProjectAdditionalItem/UpdateProjectAdditionalItemApprovalStatus`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                projectAdditionalItemID: parseInt(projAddItemId),
                customerID,
                statusID: 2, // --> 2 = rejection
              }),
            }
          );

          if (!response.ok) throw new Error(`Rejection failed with status ${response.status}`);
          setSuccess(true);
        } catch (err) {
          throw new Error("Failed to reject Additional Item: " + err.message);
        }
      } catch (error) {
        console.error("❌ Error in handleReject:", error);
        setSuccess(false);
      } finally {
        setLoading(false);
      }
    };

    handleReject();
  }, [BASE_URL]);

  if (loading) {
    return (
      <div className="center-screen">
        <div className="loader-container" aria-live="polite">
          <img
            src="/Montdor_1.png"
            alt="Company Logo"
            className="company-logo"
            onError={(e) => (e.target.style.display = "none")}
          />
          <div className="spinner"></div>
          <p className="loader-text">Processing your request...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="center-screen" style={{ backgroundColor: "#2c2139" }}>
      <div className="card-box">
        {success ? (
          <>
            <div className="icon"><FaTimes size={48} color="#e74c3c" /></div>
            <h2 className="card-title">Rejected</h2>
            <p className="card-msg">Additional Item has been Rejected.</p>
          </>
        ) : (
          <>
            <div className="icon"><FaTimes size={48} color="#888" /></div>
            <h2 className="card-title">Error</h2>
            <p className="card-msg">Unable to reject Additional Item.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default RejectAdditionalPage;
